import React, { useContext, useState } from 'react'
import { FormContext } from '../../FormContext';

const init_data = {
    "field_disabled":false,
    "field_column": "col-sm-12",
    "field_id": "reasons",
    "field_label": "Reasons",
    "field_mandatory": "yes",
    "field_options": [
      {
        "option_label": "one"
      },
      {
        "option_label": "two"
      },
      {
        "option_label": "three"
      },
      {
        "option_label": "four"
      }
    ],
    "field_type": "checkboxes",
    "field_value": ["two"]
  }



const CheckBoxes = ({ field_column,field_align,field_id, field_label, field_disabled = false, field_value=[] , field_options, field_mandatory }) => {
   
    const { handleChangeInput } = useContext(FormContext);
    
    
    return (
        <div className={`form-group ${field_column ? field_column : 'col-lg-6'}`}>
        <label>{field_label} <font color="red">{field_mandatory === 'yes' ? ' *' : ''}</font></label>
        <br />
      
        {field_options?.length > 0 && field_options.map((option, i) =>
            <>
                 <input className="form-check-input " type="checkbox" name="field_value" disabled={field_disabled||option.option_disabled} value={JSON.stringify(option)}
                checked={field_value?.includes(option.option_label)}
                onChange={event => handleChangeInput(field_id, event)} />
            <label className="form-check-label"> {option.option_label} </label>
            {field_align=="vertical" && <br/>}
            </>
        )}
       

    </div>
    )
}

export default CheckBoxes
